import { render } from "./TariffList.vue?vue&type=template&id=4f57bbf1"
import script from "./TariffList.vue?vue&type=script&lang=js"
export * from "./TariffList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__